import React from 'react'
import cx from 'classnames'

import cm from './PriceRow.module.css'

interface PriceRowProps {
  label: string
  value?: string | number
  isBold?: boolean
}

export const PriceRow = ({ label, value, isBold }: PriceRowProps) => {
  return (
    <div className={cx(cm.root)}>
      <span className="text-subheading-sm">{label}</span>
      <span className={cx('tabular-nums', { [cm.bold]: isBold })}>{value}</span>
    </div>
  )
}
